var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99292 11.4908L6.64991 14.7524C6.34404 15.4952 6.51482 16.3491 7.08286 16.9172C7.65089 17.4852 8.50477 17.656 9.24758 17.3501L12.5092 16.0071C12.9315 15.8332 13.3153 15.5774 13.6383 15.2544L22 6.89263V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5C2 3.34315 3.34315 2 5 2H17.1074L8.74564 10.3618C8.42266 10.6847 8.16683 11.0685 7.99292 11.4908Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3274 2.28698C19.9447 1.90434 19.3244 1.90434 18.9417 2.28698L17.6447 3.58402L20.416 6.35532L21.713 5.05828C22.0957 4.67564 22.0957 4.05526 21.713 3.67263L20.3274 2.28698Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3553 7.41595L16.584 4.64465L9.80628 11.4224C9.62334 11.6054 9.47844 11.8227 9.37993 12.0619L8.03691 15.3236C7.96161 15.5064 8.00366 15.7167 8.1435 15.8565C8.28335 15.9963 8.49357 16.0384 8.67645 15.9631L11.938 14.6201C12.1773 14.5216 12.3946 14.3767 12.5776 14.1937L19.3553 7.41595Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilAlt);
export default __webpack_public_path__ + "static/media/pencil-alt.11451c5938a9d9b184d95b9c7761288c.svg";
export { ForwardRef as ReactComponent };